module.exports = __webpack_public_path__ + "img/70.e1bd04c2.jpg";